module.exports = __webpack_public_path__ + "static/media/dashIcon.c3fdec7c.svg";